window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-user-mypage-contacts');
    if (!page) return;

    const confirmMsg = page.dataset.confirmDelete ?? '';

    document.querySelectorAll('.js-contact-delete-btn').forEach(function (btn) {
        btn.addEventListener('click', async function (e) {
            e.preventDefault();

            const form = btn.closest('.js-contact-delete-form');
            if (!form) return;

            const result = await window.showConfirm(confirmMsg);
            if (result) {
                form.submit();
            }
        });
    });
});

